import { Separator } from '@/shared/components/ui/separator';
import { Skeleton } from '@/shared/components/ui/skeleton';

export const SettingsSkeleton = () => {
  return (
    <div className="mx-auto flex w-full flex-col gap-6 pb-5">
      {/* Subscription section */}
      <div className="flex flex-col gap-6">
        <Skeleton className="h-5 w-24" />
        <Skeleton className="h-40 w-full rounded-2xl" />
      </div>

      <Separator />

      {/* Account section */}
      <div className="flex flex-col gap-6">
        <Skeleton className="h-5 w-20" />
        <Skeleton className="h-12 w-full rounded-xl" />
        <div className="flex flex-col gap-5">
          <Skeleton className="h-5 w-16" />
          <Skeleton className="h-5 w-32" />
          <Skeleton className="h-5 w-28" />
        </div>
      </div>

      <Separator />

      {/* Support section */}
      <div className="flex flex-col gap-6">
        <Skeleton className="h-5 w-20" />
        <div className="flex flex-col gap-1">
          <Skeleton className="h-9 w-20" />
          <Skeleton className="h-9 w-24" />
          <Skeleton className="h-9 w-14" />
          <Skeleton className="h-9 w-28" />
        </div>
      </div>
    </div>
  );
};
